import React from 'react';
import { Outlet } from 'react-router-dom';

const Gallery = () => {
    return (
        <Outlet />
    )
}

export default Gallery